import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PervalValidators, UtilisateurService } from '../../../shared';

@Component({
  selector: 'forgot-pass',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  message: string = '';
  forgotPassForm = new FormGroup({
    email: new FormControl('', [Validators.required, PervalValidators.email]),
  });
  errorMessage: string | undefined;

  constructor(
    private readonly router: Router,
    private readonly utilisateurService: UtilisateurService,
  ) {}

  async onForgotPass(): Promise<void> {
    try {
      this.errorMessage = undefined;
      if (this.forgotPassForm.invalid || !this.forgotPassForm.value.email) {
        return;
      }

      await this.utilisateurService.requestResetPassword(
        this.forgotPassForm.value.email,
      );

      await this.router.navigate(['/reinitialiser-mot-de-passe'], {
        queryParams: {
          message: 'success',
          email: this.forgotPassForm.value.email,
        },
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      this.errorMessage = error.message;
    }
  }
}
